import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {PartnerModel} from '../../partner/partner.model';
import {DistributionAccountEditRequestModel, DistributionAccountModel} from '../distribution-account.model';
import {DistributionAccountService} from '../distribution-account.service';
import {partnerListSelector} from '../../partner/partner.reducer';
import {AppStore} from '../../store/store';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {targetSystemListSelector} from '../distribution-account.reducer';
import {TargetSystemModel} from '../../target/target-system.model';
import {SubSink} from 'subsink';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
})
export class DistributionAccountEditComponent implements OnInit, OnDestroy {

  errorMessage!: string;
  partners: PartnerModel[] = [];
  distributionAccount!: DistributionAccountModel;
  partnerIdControl: FormControl = new FormControl('', Validators.required);
  description: FormControl = new FormControl('', Validators.required);

  distributionAccountEditForm: FormGroup = new FormGroup({
    partnerId: this.partnerIdControl,
    description: this.description
  });

  private subSink = new SubSink();

  constructor(private appStore: AppStore,
              private distributionAccountService: DistributionAccountService,
              private dialogRef: MatDialogRef<DistributionAccountEditComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  ngOnInit(): void {

    this.subSink.sink = this.appStore.subscribe((state: AppStore) => {
      this.partners = partnerListSelector(state);

      targetSystemListSelector(state).forEach((targetSystem: TargetSystemModel) => {
        targetSystem.distributionAccounts?.forEach((distributionAccount: DistributionAccountModel) => {
          if (distributionAccount.id === this.data.distributionAccountId) {
            this.description.setValue(distributionAccount.description);
            this.partnerIdControl.setValue(distributionAccount.partnerId);
          }
        });
      });
    });
  }


  edit() {
    this.clear();

    if (this.distributionAccountEditForm.valid) {
      const distributionAccountObject = new DistributionAccountEditRequestModel(this.distributionAccountEditForm.value);
      this.distributionAccountService.editDistributionAccount(this.data.distributionAccountId, distributionAccountObject);
      this.dialogRef.close();
    }
  }

  clear() {
    this.errorMessage = '';
  }
}
